// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleWrapper_wrapper__bUhG6","toggle":"ToggleWrapper_toggle__F-5f5"};